import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import {required} from 'utils/validators';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {TextField, TextAreaField} from 'components/Fields';

import {requestKycDocument, KYC_SECTIONS_META} from 'ducks/bookings';
import {MODALS as BASE_MODALS, closeModal} from 'ducks/modals';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const extraActions = props.getExtraActions();
  const {selectedSectionType} = props;
  const kycSectionId = props.kycSectionsIds[selectedSectionType];

  const data = {
    ...values,
    kycId: props.kycId,
    kycSection: kycSectionId,
    bookingId: props.bookingId,
    selectedSectionType // This value is for is used to generate the title of confirmation modal
  };

  props.openConfirmationModal({
    heading: `Request ${
      KYC_SECTIONS_META[selectedSectionType].VERBOSE
    } Document`,
    question:
      'Are you sure you want request additional documentation? This will send an email and/or mobile app notification to the customer.',
    confirmAction: () => {
      dispatch(requestKycDocument(data, extraActions));
      props.closeModal(BASE_MODALS.CONFIRM);
    }
  });
};

const RequestKycDocumentForm = () => (
  <form className="RequestKycDocumentForm">
    <FormField>
      <Label>Title</Label>
      <Field name="title" component={TextField} validate={required} />
    </FormField>
    <FormField className="TitleField">
      <Label>Message</Label>
      <Field name="message" component={TextAreaField} validate={required} />
    </FormField>
  </form>
);

const requestKycDocumentForm = reduxForm({
  form: 'requestKycDocument',
  onSubmit: formSubmit
})(RequestKycDocumentForm);

const mapDispatchToProps = {closeModal};

export default connect(null, mapDispatchToProps)(requestKycDocumentForm);
